import * as React from 'react'
import { make as AuthenticatedComponentRelay } from './AuthenticatedComponentRelay.bs'
import { make as UnauthenticatedComponentRelay } from './UnauthenticatedComponentRelay.bs'

export function requireAuthentication(WrappedComponent, requiredUserRole, redirectPath) {
  function AuthenticatedComponent(props) {
    return (
      <AuthenticatedComponentRelay
        requiredUserRole={requiredUserRole}
        redirectPath={redirectPath}
        renderWrappedComponent={() => <WrappedComponent {...props} />}
      />
    )
  }

  return AuthenticatedComponent
}

export const requireAuthenticatedAgent = WrappedComponent =>
  requireAuthentication(WrappedComponent, 'agent')

export const requireAuthenticatedClient = WrappedComponent =>
  requireAuthentication(WrappedComponent, 'client')

export function requireUnauthenticated(WrappedComponent) {
  function UnauthenticatedComponent(props) {
    return (
      <UnauthenticatedComponentRelay
        renderWrappedComponent={() => <WrappedComponent {...props} />}
      />
    )
  }

  return UnauthenticatedComponent
}
